import { createAction } from "@reduxjs/toolkit";
import axios from "axios";
import { FETCH_ORGANIZATION_REQUEST, FETCHING_ORGANIZATION_FAILED, FETCHING_ORGANIZATION_SUCCEEDED, INVALIDATE_ORGANIZATIONS } from "./actionTypes";
import { FetchingOrganizationFailed, FetchOrganizationRequest, Organization } from "src/types/organization";
import { call, put, takeLatest } from "redux-saga/effects";
import { PaginatedRecords } from "src/types/common";

const apiUrl = process.env.REACT_APP_API_URL;
const ORGANIZATION_BASE_URL = `${apiUrl}/api/2.0/organizations`;

export const fetchOrganization = createAction<FetchOrganizationRequest>(FETCH_ORGANIZATION_REQUEST)
const fetchingOrganizationSucceeded = createAction<PaginatedRecords<Organization>>(FETCHING_ORGANIZATION_SUCCEEDED);
const fetchingOrganizationFailed = createAction<FetchingOrganizationFailed>(FETCHING_ORGANIZATION_FAILED);
export const invalidateOrganizations = createAction<void>(INVALIDATE_ORGANIZATIONS);

const fetchOrganizationSaga = function* (action: ReturnType<typeof fetchOrganization>) {
  const { query, page, limit = 10 } = action.payload;

  const fetchOrganizationApi = async () => {
    return axios({
      method: 'GET',
      url: ORGANIZATION_BASE_URL,
      params: {
        query,
        page,
        limit
      }
    }).then((response) => response.data);
  }
  try {
    const response = yield call(fetchOrganizationApi);
    yield put(fetchingOrganizationSucceeded(response));
  } catch (error) {
    yield put(fetchingOrganizationFailed({ error }));
  }
}

export default function* organizationSaga() {
    yield takeLatest(FETCH_ORGANIZATION_REQUEST, fetchOrganizationSaga);
}